import { sprites } from '../../sprites/sprites-sidecar'
import type { IFontData2 } from '../../uiParts/fontData2'
import { fontData2 } from '../../uiParts/fontData2-sidecar'

interface IData {
  font4: IFontData2
  font6: IFontData2
  alphaLower: string
  alphaUpper: string
  extra: string
}
let _data: IData | null = null
export const getData = () => {
  if (!_data) {
    let alphaLower = 'abcdefghijklmnopqrstuvwxyz'
    let alphaUpper = alphaLower.toUpperCase()
    let extra = "1234567890.!?/:,+-%()*'$_"
    let font4 = fontData2.create('font-4', {
      charSpacing: 1,
      charWidth: 3,
      charHeight: 6,
      data: [
        {
          chars: alphaUpper,
          sprite: sprites.goatFont41,
        },
        {
          chars: extra,
          sprite: sprites.goatFont42,
        },
      ],
    })

    // Adjust widths
    fontData2.setWidths(font4, 'mw', 5, 1)
    fontData2.setWidths(font4, 'nx', 4, 1)
    fontData2.setWidths(font4, 'q', 4, 0)
    fontData2.setWidths(font4, '?', 4, 1)
    fontData2.setWidths(font4, '%', 4, 1)
    fontData2.setWidths(font4, '*', 5, 1)
    fontData2.setWidths(font4, '/', 4, 0)
    fontData2.setWidths(font4, '1:', 1, -2)
    fontData2.setWidths(font4, ':', 1, -2)
    //fontData2.setWidths(font4, '.', 2, -1)
    fontData2.setWidths(font4, '.', 1, -2)

    let font6 = fontData2.create('font-62', {
      charSpacing: 1,
      charWidth: 3,
      charHeight: 8,
      data: [
        {
          chars: alphaUpper,
          sprite: sprites.goatFont621,
        },
        {
          chars: alphaLower,
          sprite: sprites.goatFont622,
        },
        {
          chars: extra,
          sprite: sprites.goatFont623,
        },
      ],
    })

    // Adjust widths
    fontData2.setWidths(font6, 'MZ', 5, 1)
    fontData2.setWidths(font6, 'NY', 4, 1)
    fontData2.setWidths(font6, 'X', 5, 1)
    fontData2.setWidths(font6, 'Q', 4, 0)
    fontData2.setWidths(font6, 'W', 5, 1)
    fontData2.setWidths(font6, 'F', 3, 0)

    fontData2.setWidths(font6, 'e', 3, 0)
    fontData2.setWidths(font6, 'a', 4, 0)
    fontData2.setWidths(font6, 'sf', 2, 0)
    fontData2.setWidths(font6, 'u', 3, 0)
    fontData2.setWidths(font6, 'il', 1, -1)
    fontData2.setWidths(font6, 'mw', 5, 1)
    fontData2.setWidths(font6, 'z', 4, 1)
    fontData2.setWidths(font6, 'n', 4, 1)
    fontData2.setWidths(font6, 'y', 3, 0)
    fontData2.setWidths(font6, 'x', 4, 1)
    fontData2.setWidths(font6, 'q', 3, 0)

    fontData2.setWidths(font6, '?', 4, 0)
    fontData2.setWidths(font6, '%', 4, 1)
    fontData2.setWidths(font6, '/', 4, 0)
    fontData2.setWidths(font6, '1', 1, -2)
    fontData2.setWidths(font6, ':', 2, -1)
    fontData2.setWidths(font6, '.', 2, -1, 0)
    fontData2.setWidths(font6, '!', 2, -1, 0)
    fontData2.setWidths(font6, ',', 2, -1, 2)
    fontData2.setWidths(font6, "'", 1, -1, 0)
    _data = {
      font4,
      font6,
      alphaLower,
      alphaUpper,
      extra,
    }
  }
  return _data
}
